import React from "react";

const ExploreProfiles = () => {
  return <h1>Explore Profiles its work</h1>;
};

export default ExploreProfiles;
